import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const ERROR_INFO = {
  400: { title: 'Некорректный запрос', desc: 'Сервер не смог обработать запрос. Проверьте правильность введённого адреса.', icon: 'alert-circle-outline' },
  401: { title: 'Требуется авторизация', desc: 'Для доступа к этой странице необходимо авторизоваться.', icon: 'lock-closed-outline' },
  403: { title: 'Доступ запрещён', desc: 'У вас нет прав для просмотра этой страницы.', icon: 'shield-outline' },
  404: { title: 'Страница не найдена', desc: 'Запрашиваемая страница не существует или была перемещена.', icon: 'search-outline' },
  500: { title: 'Ошибка сервера', desc: 'На сервере произошла внутренняя ошибка. Попробуйте обновить страницу позже.', icon: 'server-outline' },
  502: { title: 'Ошибка шлюза', desc: 'Сервер получил некорректный ответ от вышестоящего сервера.', icon: 'cloud-offline-outline' },
  503: { title: 'Сервис недоступен', desc: 'Сервер временно недоступен. Возможно, ведутся технические работы.', icon: 'construct-outline' },
  504: { title: 'Превышено время ожидания', desc: 'Сервер не дождался ответа от вышестоящего сервера.', icon: 'hourglass-outline' },
};

const ErrorScreen = ({ code: propCode }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const code = propCode || searchParams.get('code') || '404';
  const info = ERROR_INFO[code] || ERROR_INFO[404];

  return (
    <div className="screen-transition" style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: 'calc(100vh - 140px)', padding: 24,
    }}>
      <div style={{
        width: '100%', maxWidth: 400, textAlign: 'center',
        background: 'var(--surface-secondary)', borderRadius: 20,
        border: '0.5px solid var(--border)', padding: '32px 24px',
        boxShadow: '0 8px 24px var(--shadow-color)',
        animation: 'screenFadeIn 0.4s ease-out',
      }}>
        <div style={{
          fontSize: 80, fontWeight: 700, lineHeight: 1,
          color: 'var(--border)', marginBottom: 4,
        }}>{code}</div>

        <div style={{
          width: 56, height: 56, borderRadius: 16,
          background: 'rgba(255,59,48,0.1)', border: '0.5px solid rgba(255,59,48,0.2)',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 16,
        }}>
          <ion-icon name={info.icon} style={{ fontSize: 28, color: '#ff3b30' }}></ion-icon>
        </div>

        <div style={{ fontSize: 20, fontWeight: 600, color: 'var(--text)', marginBottom: 8 }}>
          {info.title}
        </div>
        <div style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.5, marginBottom: 24 }}>
          {info.desc}
        </div>

        <button onClick={() => navigate('/schedule')} style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '12px 24px', borderRadius: 14, border: 'none',
          background: 'var(--accent-glass)', color: 'var(--accent)',
          fontSize: 15, fontWeight: 600, fontFamily: 'inherit',
          cursor: 'pointer', transition: 'background 0.2s',
        }}>
          <ion-icon name="home-outline" style={{ fontSize: 18 }}></ion-icon>
          На главную
        </button>
      </div>
    </div>
  );
};

export default ErrorScreen;
